import type { CommentTargetType } from '../../types/comments';

// TanStack query keys for comments. Centralized so socket-event handlers
// and mutations can invalidate consistently.
export const commentKeys = {
  all: ['comments'] as const,
  list: (targetType: CommentTargetType, targetId: string) =>
    ['comments', 'list', targetType, targetId] as const,
  replies: (parentId: string) => ['comments', 'replies', parentId] as const,
  single: (id: string) => ['comments', 'single', id] as const,
};
